<template>
    <div class="news">
        <div class="model-box">
            <el-radio-group v-model="newsData.modelType">
                <div class="model-item">
                    <img src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"/>
                    <el-radio :label="1">模板1</el-radio>
                </div>
                <div class="model-item">
                    <img src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"/>
                    <el-radio :label="2">模板2</el-radio>
                </div>
                <div class="model-item">
                    <img src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"/>
                    <el-radio :label="3">模板3</el-radio>
                </div>
                <div class="model-item">
                    <img src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"/>
                    <el-radio :label="4">模板4</el-radio>
                </div>
            </el-radio-group>
        </div>
        <div class="news-info-box">
            <div class="news-info-item">
                <span class="title">语言</span>
                <el-select :value="newsData.lang" @change="handleQueryChange('language', $event)" placeholder="请选择">
                    <el-option v-for="item in languageList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="news-info-item">
                <span class="title">标题</span>
                <el-input type="text" placeholder="请输入标题" v-model="newsData.newsTitle" maxlength="100" show-word-limit
                          style="width: 90%;border: 0px"></el-input>
            </div>
            <div class="news-info-item">
                <span class="title">副标题</span>
                <el-input type="text" placeholder="请输入摘要/副标题（非必填）" v-model="newsData.newsSubtitle" maxlength="100"
                          show-word-limit
                          style="width: 90%;border: 0px"></el-input>
            </div>
            <div class="news-info-item">
                <span class="title">作者</span>
                <el-input type="text" placeholder="请输入作者姓名（非必填）" v-model="newsData.authorName" maxlength="20"
                          show-word-limit
                          style="width: 90%;border: 0px"></el-input>
            </div>
            <div class="news-info-item">
                <span class="title">交易对</span>
                <span style="color: gainsboro;padding-left: 20px" v-if="tradePair.length<=0">暂无选择</span>
                <el-tag :key="pair" v-for="pair in tradePair" closable :disable-transitions="false"
                        @close="handlePairClose(pair)" style="margin-right: 10px;margin-bottom: 5px">
                    {{pair}}
                </el-tag>
                <el-tag type="danger" @click.native="openPairDialog()" style="margin-left: 20px;margin-bottom: 5px">
                    + 交易对
                </el-tag>
            </div>
            <div class="news-info-item">
                <span class="title">已上传的图片</span>
                <span style="color: gainsboro;padding-left: 20px" v-if="imageUrls.length<=0">暂未上传</span>
                <el-tag :key="img" v-for="img in imageUrls" closable :disable-transitions="false"
                        @close="handleImgClose(img)"
                        style="margin-right: 30px;margin-bottom:5px;padding:0 0;width: 50px;height: 50px">
                    <img :src="img" style="width: 50px;height: 50px"/>
                </el-tag>
            </div>
            <div class="news-info-item" style="border: 0px">
                <span class="title">正文</span>
                <el-popover @show="qrCode"
                            placement="top-start"
                            width="150"
                            trigger="hover">
                    <div id="qrcode"></div>
                    <el-tag type="danger" slot="reference"
                            style="color:#EC6D56;font-size:14px;font-family:Microsoft YaHei;float: right;margin-left: 20px;cursor: pointer">
                        手机预览
                    </el-tag>
                </el-popover>
                <el-tag type="danger" @click.native="connectSocket"
                        style="color:#EC6D56;font-size:14px;font-family:Microsoft YaHei;float: right;margin-left: 20px;cursor: pointer">
                    连接socket
                </el-tag>
                <div style="width: 1400px;margin-top: 40px;">
                    <el-ueditor :value="newsData.richText" @change="handleFormChangeContent" ref="uediter"
                                style="width: 676px;display: inline-block"></el-ueditor>
                    <div class="left-detail-box">
                        <div class="content-box" style="width: 100%;height: 100%">
                            <div class="title" v-if="newsData.newsTitle!=''">{{newsData.newsTitle}}</div>
                            <div class="author" v-if="newsData.authorName!=''">
                                作者：{{newsData.authorName}}
                            </div>
                            <div class="time" v-if="newsData.createTime!=''">
                                {{newsData.createTime | moment}}
                            </div>
                            <div class="content">
                                <div class="abstract" v-if="newsData.newsSubtitle!=''">
                                    {{newsData.newsSubtitle}}
                                </div>
                                <div class="detail" v-html="newsData.richText"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="news-info-buttom">
                <el-button type="danger" @click="saveNews">提 交</el-button>
            </div>
        </div>

        <!--插入交易对弹框-->
        <el-dialog title="插入交易对" :visible.sync="pairDialogVisible" width="400px" @close="clearDataTwo">
            <el-select placeholder="请选择" v-model="pair" filterable
                       style="width: 90%" size="small">
                <el-option v-for="(item,index) in pairOptions" :key="item.exchangeCoin+'_'+item.anchoredCoin+'_'+index"
                           :label="item.exchangeCoin+'/'+item.anchoredCoin"
                           :value="item.exchangeCoin+'_'+item.anchoredCoin">
                </el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="insertCard('PAIRCARD')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import {mapMutations, mapState} from 'vuex';
    import elUeditor from './editor/elUeditor';
    import api from '../api';
    import userInfoHelper from '../../../common/userInfo';
    import {WSPREVIEW, HTTPPREVIEW} from "../common/wsAddress";
    import moment from 'moment';
    import QRCode from 'qrcodejs2'

    export default {
        name: "News",
        components: {elUeditor},
        data() {
            return {
                newsData: {
                    modelType: 1,
                    newsTitle: "",
                    newsSubtitle: "",
                    authorName: "",
                    richText: "",
                    pureText: "",
                    imageUrls: "",
                    tradePair: "",
                    lang: "zh",
                    newsType: "NEWS",
                    userName: ""
                },
                imageUrls: [],
                tradePair: [],
                pairDialogVisible: false, //交易对弹框
                pairOptions: [], //交易对弹框
                pair: '',
                wsUri: WSPREVIEW + "/preview?id=",
                previewUri: HTTPPREVIEW + "/cms/news/app/preview.html",
                previewId: userInfoHelper.get().userName,
                websocket: null,
                publishTime: "",
            }
        },
        computed: {
            ...mapState('cmsManage', ['languageList', 'query'])
        },
        watch: {
            "newsData.newsTitle": function () {
                this.sendData();
            },
            "newsData.authorName": function () {
                this.sendData();
            },
            "newsData.richText": function () {
                this.sendData();
            }
        },
        created() {
            this.previewWebSocket();
        },
        beforeDestroy() {
            this.websocket.close();
        },
        methods: {
            ...mapMutations('cmsManage', ['changeQuery']),
            handleQueryChange(type, value) {
                this.changeQuery({
                    ...this.query,
                    [type]: value
                });
                this.newsData.lang = value;
            },
            saveNews() {
                this.newsData.userName = userInfoHelper.get().userName;
                if (this.newsData.lang == "") {
                    this.$message.success('请选择语言类型！');
                    return;
                }
                if (this.newsData.newsTitle == "") {
                    this.$message.success('标题不能为空！');
                    return;
                }
                this.newsData.tradePair = this.tradePair.join(",");
                this.newsData.imageUrls = this.imageUrls.join(",");
                this.$confirm('确认提交吗？提交后将不能修改！', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.addNews(this.newsData).then(({data}) => {
                        this.$message.success('提交成功！');
                    });
                }).catch(() => {
                });
            },
            handleFormChangeContent(val, text) {
                this.newsData.pureText = text;
                this.newsData.richText = val;
                this.getImgSrc(val);
            },
            getImgSrc(html) {
                let tem;
                const reg = /<img.+?src=('|")?([^'"]+)('|")?(?:\s+|>)/gim;
                this.imageUrls = [];
                while (tem = reg.exec(html)) {
                    this.imageUrls.push(tem[2]);
                }
            },
            openPairDialog() {
                api.getAllSupportingPairs().then(({data}) => {
                    this.pairOptions = data;
                });
                this.pairDialogVisible = true;
            },
            handlePairClose(pair) {
                this.tradePair.splice(this.tradePair.indexOf(pair), 1);
            },
            handleImgClose(img) {
                this.imageUrls.splice(this.imageUrls.indexOf(img), 1);
            },
            insertCard(type) {
                switch (type) {
                    case 'PAIRCARD':  //交易对
                        if (this.pair == "") {
                            this.$message.success('请选择交易对！');
                            return;
                        }
                        // let pairCardUrl = "/cms/cms/news/pairCard.html?pair=" + this.pair;
                        // this.newsData.richText += '<iframe src="' + pairCardUrl + '" height="50px" width="100%" scrolling="no" frameborder="0"></iframe>';
                        // this.$refs.uediter.insertDefineHtml('<iframe src="' + pairCardUrl + '" height="50px" width="100%" scrolling="no" frameborder="0"></iframe>');
                        if (this.tradePair.indexOf(this.pair) == -1) {
                            this.tradePair.push(this.pair);
                        }
                        this.pairDialogVisible = false;
                        break;
                }
            },
            clearDataTwo() {
                this.pair = "";
            },
            sendData() {
                if(this.websocket.readyState == 3){
                    this.$message.success('socket连接已断开！');
                    return;
                }
                this.websocket.send(JSON.stringify({
                    newsTitle: this.newsData.newsTitle,
                    authorName: this.newsData.authorName,
                    publishTime: moment((new Date()).getTime()).format("YYYY-MM-DD HH:mm:ss"),
                    richText: this.newsData.richText
                }));
            },
            previewWebSocket() {
                let _othis = this;
                this.websocket = new WebSocket(this.wsUri + this.previewId);
                this.websocket.onopen = function (evt) {
                    _othis.$message.success('socket连接成功！');
                };
                this.websocket.onclose = function (evt) {
                    _othis.$message.success('socket连接已断开！');
                };
                this.websocket.onmessage = function (evt) {

                };
                this.websocket.onerror = function (evt) {
                    _othis.$message.success('socket连接错误！');
                };
            },
            qrCode() {
                let _othis = this;
                console.log(_othis.previewUri + "?id=" + _othis.previewId + "&newsTitle=" + _othis.newsData.newsTitle + "&authorName=" + _othis.newsData.authorName + "&publishTime=" + _othis.publishTime)
                this.$nextTick(function () {
                    document.getElementById("qrcode").innerHTML = "";
                    let qrcode = new QRCode("qrcode", {
                        width: 150,
                        height: 150,
                        text: _othis.previewUri + "?id=" + _othis.previewId,
                        colorDark: "#000000",
                        colorLight: "#d9d9d9"
                    });
                });
            },
            connectSocket() {
                this.websocket.close();
                this.previewWebSocket();
            }
        }
    }
</script>

<style type="text/css">
    .news .el-input__inner {
        border: 0px
    }
    .left-detail-box .detail * {
        margin-top: 0px;
    }
</style>
<style lang="less" scoped>
    .news {
        min-width: 1500px;

        .model-box {
            background-color: #FFFFFF;
            .model-item {
                float: left;
                margin-left: 30px;
                margin-top: 30px;
                margin-bottom: 30px;
                img {
                    width: 100px;
                    height: 100px;
                    display: block;
                    margin-bottom: 20px;
                }
            }
        }

        .news-info-box {
            background-color: #FFFFFF;
            margin-top: 30px;

            .news-info-item {
                border-bottom: 1px solid rgba(54, 67, 101, 0.09803921568627452);
                padding-top: 20px;
                padding-bottom: 20px;
                width: 95%;
                margin: auto;
                .title {
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);
                    letter-spacing: 10px;
                }

                .left-detail-box {
                    font-size: 20px;
                    float: right;
                    height: 1029px;
                    width: 676px;
                    display: inline-block;
                    background-color: #FFFFFF;
                    border: 1px solid gray;
                    overflow-y: auto;

                    .title {
                        width: 100%;
                        text-align: center;
                        font-size: 100%;
                        font-family: Microsoft YaHei;
                        font-weight: bold;
                        color: rgba(51, 51, 51, 1);
                        letter-spacing: 5px;
                        margin-top: 30px;
                    }
                    .author {
                        font-size: 70%;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        letter-spacing: 3px;
                        text-align: center;
                        margin-top: 20px;
                    }
                    .time {
                        font-size: 70%;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: rgba(172, 172, 172, 1);
                        letter-spacing: 2px;
                        margin-top: 20px;
                        text-align: center;
                    }
                    .content {
                        width: 95%;
                        margin: auto;
                        margin-top: 20px;

                        .abstract {
                            font-size: 80%;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            line-height: 1.5;
                            color: rgba(141, 141, 141, 1);
                        }

                        .detail {
                            font-size: 16px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            line-height: 1.75;
                            color: rgba(51, 51, 51, 1);
                            margin-top: 30px;
                        }
                    }

                }
            }

            .news-info-buttom {
                text-align: center;
                margin: 50px 0px;
                height: 70px;
            }
        }
    }
</style>